var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_padding h-80vh overflow-scroll"},_vm._l((_vm.initListData),function(e){return _c('user-card',{key:e.id,attrs:{"itemData":e}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }